<h3 class="tw-mb-2.5 tw-mt-4">0 {{'mbcart.itemsInYourCart' | cxTranslate}}</h3>
<div class="tw-border-solid tw-border tw-border-grey-400 tw-rounded tw-p-6 tw-mb-4">
  <div class="tw-text-center tw-flex tw-flex-col tw-justify-center"
       data-cy="mb-empty-cart-section">
    <h4 class="tw-m-0 tw-mb-2 tw-text-[#878787]"
        [innerHTML]="'emptyCart.carEmptyMessage'| cxTranslate"></h4>
    <div class=""
         data-cy="mb-empty-cart-browse">
      <mb-link [useSlot]="true" [linkData]="{ url: allProductCategoriesUrl }">
        <span> {{'emptyCart.browseProducts'| cxTranslate}} </span>
      </mb-link>
    </div>
  </div>
</div>
